<template>
  <div class="ship-information" id="ship-information">
    <div class="divider"></div>
    <img src="../../static/images/graphics/us-forces-stamp.png" alt="US Forces Stamp" id="forces-stamp">
    <img src="../../static/images/graphics/classified.png" alt="US Forces Stamp" id="classified-stamp">

    <div class="ship-information-overflow-wrapper">
      <transition
        :name="transitionName"
        @after-leave="afterLeave"
        @enter="enter"
      >
        <div class="ship-information-item-wrapper" v-show="showShip">
          <div class="ibvf"></div>
          <ship-information-item @navigate="swipeNavigateHandler"></ship-information-item>
        </div>
      </transition>
    </div>

    <div class="info-nav left" @click='changeInfo(0)'>
      <img src="../../static/images/graphics/arrow.svg" alt="Arrow">
    </div>
    <div class="info-nav right" @click='changeInfo(1)'>
      <img src="../../static/images/graphics/arrow.svg" alt="Arrow">
    </div>
    <div class="close" @click='hideShipInformation'>
      <img src="../../static/images/graphics/close.svg" alt="Close">
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';
  import ShipInformationItem from '@/components/ShipInformationItem';
  import ships from '@/ships';

  export default {
    name: 'shipInformation',
    data() {
      return {
        showShip: true,
        nextShipNumber: null,
        transitionName: 'shipTransitionRight',
      };
    },
    computed: {
      ...mapGetters('ships', {
        shipInfo: 'currentShipInformation',
        nextShip: 'nextShip',
        previousShip: 'previousShip',
        shipImageLink: 'shipImageLink',
        currentShip: 'currentShip',
      }),
    },
    methods: {
      ...mapMutations('ships', ['setCurrentShip']),
      ...mapMutations('ui', ['setDrawerState']),
      changeInfo(b) {
        let nextShip;
        if (b) {
          nextShip = this.currentShip + 1;
          if (nextShip > (ships.length - 1)) {
            nextShip = 0;
          }
          this.goToShip({ shipIndex: nextShip, transitionName: 'shipTransitionLeft' });
        } else {
          nextShip = this.currentShip - 1;
          if (nextShip < 0) {
            nextShip = ships.length - 1;
          }
          this.goToShip({ shipIndex: nextShip, transitionName: 'shipTransitionRight' });
        }
      },
      swipeNavigateHandler(direction) {
        if (direction < 0) {
          this.changeInfo(1);
        } else {
          this.changeInfo(0);
        }
      },
      hideShipInformation() {
        this.setDrawerState({ open: false });
      },
      goToShip({ shipIndex, transitionName }) {
        this.transitionName = transitionName;
        this.showShip = false;
        this.nextShipNumber = shipIndex;
      },
      afterLeave() {
        this.setCurrentShip({ shipIndex: this.nextShipNumber });
        this.showShip = true;
      },
      enter() {
        document.getElementById('content-wrapper').scrollTop = 0;
      },
    },
    components: {
      ShipInformationItem,
    },
  };
</script>

<style lang="scss" scoped>
  .ibvf {
    height: 100%;
    width: 0;
    display: none;
    vertical-align: middle;
  }

  // Ship Transition Right
  .shipTransitionRight-enter-active {
    transform: translate(-100%, 0);
  }

  .shipTransitionRight-enter-to {
    transform: translate(-100%, 0);
    transition: none !important;
  }

  .shipTransitionRight-leave-active {
    transform: translate(100%, 0);
  }

  // Ship Transition Left
  .shipTransitionLeft-enter-active {
    transform: translate(100%, 0);
  }

  .shipTransitionLeft-enter-to {
    transform: translate(100%, 0);
    transition: none !important;
  }

  .shipTransitionLeft-leave-active {
    transform: translate(-100%, 0);
  }


  .ship-information-item-wrapper {
    transition: transform 550ms;
    height: 100%;
    position: relative;
    overflow: hidden;
    font-size: 0;
    text-align: center;
  }

  .ship-information-overflow-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    right: 0;
    overflow-x: hidden;
  }

  .ship-information {
    width: 100%;
    height: 100%;
    background-color: rgba(1, 2, 1, 0.85);
    color: #fff;
    overflow-y: hidden;
    transition: opacity 300ms;
    position: relative;
    display: block !important;

    transform: translateX(100%);

    &.active {
      opacity: 1;
      pointer-events: all;
    }

    h3 {
      font-size: 25px;
      margin: 0 0 20px;
      font-weight: bold;
      display: inline-block;
      max-width: 55%;
    }

    p {
      font-size: 14px;
      line-height: 23px;
    }

    .coordinate-string {
      margin: 0;
    }
  }

  .info-nav {
    cursor: pointer;
    width: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: auto;
    }

    &.left {
      img {
        transform: scale(-1);
      }
      left: 2%;
    }

    &.right {
      right: 2%;
    }
  }

  .header-section {
    // display: flex;
    margin-top: 75px;
    .flex-half {
      width: 50%;
      margin-top: 75px;

      img {
        max-width: 100%;
      }
    }
  }

  .cta-container {
    margin: 20px 0 30px;
  }

  .cta {
    color: #fff;
    text-decoration: none;
    background-color: #7dbf72;
    width: auto;
    display: inline-block;
    padding: 7px 20px 10px;
    border-radius: 8px;
    cursor: pointer;
    p {
      color: #fff;
      text-decoration: none;
      margin: 0;
      font-weight: bold;
    }
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    width: 31px;
    height: 31px;
    img {
      width: 100%;
      height: auto;
    }
  }

  #forces-stamp {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.03;
    width: 70%;
    max-width: 323px;
    height: auto;
    pointer-events: none;
  }

  #classified-stamp {
     position: absolute;
     bottom: 10%;
     right: 0;
     width: 100%;
     max-width: 570px;
     pointer-events: none;
     opacity: 0.1;
   }

  #ship-image {
    float: right;
    display: inline-block;
    width: 40%;
    max-width: 300px;
    height: auto;
    img {
      max-width: 100%;
      height: auto;
    }
  }

  .divider {
    position: absolute;
    top: 50%;
    left: 2%;
    transform: translateY(-50%);
    width: 1px;
    height: 72.2%;
    display: none;
    background: #fff;
  }

  @media screen and (min-width: 768px) {
    .ship-information {
      position: relative;

      h3 {
        font-size: 42px;
        line-height: 58px;
      }
      p {
        font-size: 18px;
        line-height: 26px;
      }
      .coordinate-string {
        margin: 15px 0;
      }
    }

    .bio {
      margin-top: 70px;
    }
  }

  @media screen and (min-width: 992px) {
    .ibvf {
      display: inline-block;
    }
    .ship-information-overflow-wrapper {
      width: 98%;
    }

    .ship-information {
      width: 60%;
      position: absolute;
      left: 40%;
      top: 0;
      pointer-events: all;
      opacity: 1;
      display: block !important;
      transform: translateX(0%);
    }

    .divider {
      display: inline-block;
    }

    .info-nav {
      &.left {
        left: 5%;
      }

      &.right {
        right: 5%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ShipInformation.vue?d86cf686